import userDataService from 'common/services/userData.service.js';
import socialSecurityDataService from './services/social-security.data.service';
import socialSecurityService from './services/social-security.service';

let socialSecurityCommon = angular.module('social-security.common', [])

  .service('userDataService', userDataService)
  .service('socialSecurityDataService', socialSecurityDataService)
  .service('socialSecurityService', socialSecurityService)

  .name;

export default socialSecurityCommon;



// WEBPACK FOOTER //
// ./client/app/social-security.module/common/social-security.common.js